import { saveAs } from '@progress/kendo-file-saver';

export function saveFile(fileName: string, data: Blob): void {
  saveAs(data, fileName);
}
